module.exports = __webpack_public_path__ + "img/logo-bar.9a580230.jpg";